const initialState = {
    spacingStylesheet: null // stylesheet containing custom spacing rules
};

export default (state = initialState, action) => {
    switch(action.type){
        case "styles/INSERT_SPACING_RULES":
            return {
                ...state,
                spacingStylesheet: action.payload.spacingStylesheet
            };
        default:
            return state;
    }
};
